import { render, staticRenderFns } from "./giftWidget.vue?vue&type=template&id=348fd710&lang=pug"
import script from "./giftWidget.vue?vue&type=script&lang=js"
export * from "./giftWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports